import { render, staticRenderFns } from "./SimpleInspection.vue?vue&type=template&id=aed9d18a&scoped=true&"
import script from "./SimpleInspection.vue?vue&type=script&lang=js&"
export * from "./SimpleInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed9d18a",
  null
  
)

export default component.exports